import { useState } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import SiteSelect from '../site/select';

export default function moveClient({ client, sites, processing, handleMove, handleCancel }) {
  const [toSiteId, setToSiteId] = useState(client.siteId);

  function handleUpdateClick() {
    console.log(handleMove);
    handleMove(toSiteId);
  }

  function resetForm() {
    setToSiteId(client.siteId);
    if (handleCancel) {
      handleCancel();
    }
  }

  return (
    <Box component="form" noValidate>
      <div>
        <FormControl fullWidth margin="normal" variant="outlined">
          <SiteSelect
            sites={sites}
            selectedSiteId={toSiteId || ''}
            setSelectedSiteId={setToSiteId}
          />
        </FormControl>
      </div>
      <Box display="flex" justifyContent="flex-end" alignItems="flex-end">
        <Button disabled={processing || null} variant="outlined" color="error" onClick={resetForm}>
          Cancel
        </Button>
        <Button disabled={processing || null} sx={{ ml: 1 }} variant="contained" onClick={handleUpdateClick}>
          Save
        </Button>
      </Box>
    </Box>
  );
}
